import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = { class: "main" }
const _hoisted_2 = {
  id: "Nav",
  class: "left"
}
const _hoisted_3 = { class: "back" }
const _hoisted_4 = ["aria-label"]
const _hoisted_5 = { class: "content" }
const _hoisted_6 = { class: "maintitle s60" }
const _hoisted_7 = { class: "desc" }
const _hoisted_8 = {
  id: "Main",
  class: "right"
}
const _hoisted_9 = {
  class: "logo",
  "data-color": "cyan50"
}
const _hoisted_10 = ["href"]
const _hoisted_11 = ["alt"]
const _hoisted_12 = { class: "intro" }
const _hoisted_13 = { class: "maintitle s36" }
const _hoisted_14 = {
  ref: "form",
  class: "form"
}
const _hoisted_15 = {
  key: 0,
  class: "item"
}
const _hoisted_16 = { for: "UserName" }
const _hoisted_17 = { class: "item" }
const _hoisted_18 = { for: "Email" }
const _hoisted_19 = {
  key: 1,
  class: "item"
}
const _hoisted_20 = { for: "EmailCheck" }
const _hoisted_21 = {
  key: 2,
  class: "desc small"
}
const _hoisted_22 = ["href"]
const _hoisted_23 = {
  class: "item",
  "data-label": "top"
}
const _hoisted_24 = { for: "ProfileSegment" }
const _hoisted_25 = { value: null }
const _hoisted_26 = ["value"]
const _hoisted_27 = {
  class: "item",
  "data-type": "list"
}
const _hoisted_28 = { class: "checkbox" }
const _hoisted_29 = { for: "IsNewsletterSubscription" }
const _hoisted_30 = ["innerHTML"]
const _hoisted_31 = {
  key: 0,
  class: "validation-summary-errors"
}
const _hoisted_32 = { class: "cta" }

import { ref, onBeforeMount } from "vue";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";


export default /*@__PURE__*/_defineComponent({
  __name: 'AccountExternalRegister',
  props: {
    userName: {},
    email: {},
    returnUrl: {}
  },
  setup(__props: any) {

const props = __props;

const localizer = Localizer;
const formHelper = FormHelper;
const routes = (window as any).App.routes;

const isLoading = ref(false);
const isSuccess = ref(false);
const options = ref<any>(null);
const profileSegments = ref<any[]>([]);
const formData = ref<any>({ profileSegment: null, isNewsletterSubscription: false });
const validationErrors = ref<any[]>([]);

onBeforeMount(async () => {
    options.value = (await Axios.post(routes.Account_User_GetOptions, null, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;
    profileSegments.value = options.value.profileSegments;
    formData.value.userName = props.userName ?? null;
    formData.value.email = props.email ?? null;
});

async function submitForm() {
    FormHelper.removeFocus();
    validationErrors.value = [];
    isLoading.value = true;
    try {
        let result = (await Axios.post(routes.Account_External_ExternalRegister, formData.value, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;
        isSuccess.value = true;
        window.location.href = result.redirectUrl ? result.redirectUrl : (props.returnUrl ? props.returnUrl : "/");
    } catch (error: any) {
        if (error.response && error.response.status === 400) {
            validationErrors.value = FormHelper.getValidationErrors(error.response.data);
        }
    }
    isLoading.value = false;
}

function isEmailInUse(): boolean {
    return (validationErrors.value.length !== 0 && validationErrors.value.filter((x: any) => x.message === localizer.get("Account.Common.Email_InUse")).length > 0);
}

function goBack() {
    props.returnUrl ? window.location.href = props.returnUrl : history.back();
}

return (_ctx: any,_cache: any) => {
  const _component_app_footer = _resolveComponent("app-footer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (goBack())),
          class: "button icon fastic-circle-left",
          "aria-label": _unref(localizer).get('App.Common.PageBack')
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("h1", _hoisted_6, _toDisplayString(_unref(localizer).get("Account.Common.Register_Title")), 1),
        _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(localizer).get("Account.Common.Register_Description")), 1)
      ]),
      _createVNode(_component_app_footer)
    ]),
    _createElementVNode("main", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("a", {
          href: _unref(routes).Home
        }, [
          _createElementVNode("img", {
            src: "/images/logo.svg",
            width: "125",
            height: "35",
            alt: _unref(localizer).get('App.Common.Beghelli')
          }, null, 8, _hoisted_11)
        ], 8, _hoisted_10)
      ]),
      (options.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onKeydown: _cache[7] || (_cache[7] = _withKeys(_withModifiers(($event: any) => (submitForm()), ["prevent","stop"]), ["enter"])),
            class: "content"
          }, [
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("h2", _hoisted_13, _toDisplayString(_unref(localizer).get("Account.ExternalRegister.CompleteProfile")), 1)
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("fieldset", null, [
                (options.value.isUserName)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("label", _hoisted_16, _toDisplayString(_unref(localizer).get("Account.Common.UserName")), 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        id: "UserName",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.userName) = $event)),
                        class: _normalizeClass([{ 'input-validation-error': _unref(formHelper).isControlValidationError('UserName', validationErrors.value) }, 'input w300'])
                      }, null, 2), [
                        [
                          _vModelText,
                          formData.value.userName,
                          void 0,
                          { lazy: true }
                        ]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("label", _hoisted_18, _toDisplayString(_unref(localizer).get("App.Form.Email")), 1),
                  _withDirectives(_createElementVNode("input", {
                    type: "email",
                    id: "Email",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.email) = $event)),
                    class: _normalizeClass([{ 'input-validation-error': _unref(formHelper).isControlValidationError('Email', validationErrors.value) }, 'input w300'])
                  }, null, 2), [
                    [
                      _vModelText,
                      formData.value.email,
                      void 0,
                      { lazy: true }
                    ]
                  ])
                ]),
                (options.value.isEmailCheck)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                      _createElementVNode("label", _hoisted_20, _toDisplayString(_unref(localizer).get("Account.Common.EmailCheck")), 1),
                      _withDirectives(_createElementVNode("input", {
                        type: "email",
                        id: "EmailCheck",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.emailCheck) = $event)),
                        class: _normalizeClass([{ 'input-validation-error': _unref(formHelper).isControlValidationError('EmailCheck', validationErrors.value) }, 'input w300'])
                      }, null, 2), [
                        [
                          _vModelText,
                          formData.value.emailCheck,
                          void 0,
                          { lazy: true }
                        ]
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (isEmailInUse())
                  ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                      _createTextVNode(_toDisplayString(_unref(localizer).get("Account.Common.Email_InUse_RetrieveText")) + " ", 1),
                      _createElementVNode("a", {
                        href: _unref(routes).Account_User_PasswordRemind
                      }, _toDisplayString(_unref(localizer).get("Account.Common.Email_InUse_RetrieveLink")), 9, _hoisted_22)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("label", _hoisted_24, _toDisplayString(_unref(localizer).get("App.Common.AddFunctionalities")), 1),
                  _withDirectives(_createElementVNode("select", {
                    id: "ProfileSegment",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.profileSegment) = $event)),
                    class: _normalizeClass([{ 'input-validation-error': _unref(formHelper).isControlValidationError('ProfileSegment', validationErrors.value) }, 'input w460'])
                  }, [
                    _createElementVNode("option", _hoisted_25, _toDisplayString(_unref(localizer).get("App.Form.Select")), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(profileSegments.value, (profileSegment, index) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: profileSegment.value,
                        key: index
                      }, _toDisplayString(profileSegment.title), 9, _hoisted_26))
                    }), 128))
                  ], 2), [
                    [_vModelSelect, formData.value.profileSegment]
                  ])
                ])
              ]),
              _createElementVNode("fieldset", null, [
                _createElementVNode("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      id: "IsNewsletterSubscription",
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.isNewsletterSubscription) = $event))
                    }, null, 512), [
                      [_vModelCheckbox, formData.value.isNewsletterSubscription]
                    ]),
                    _createElementVNode("label", _hoisted_29, _toDisplayString(_unref(localizer).get('App.Form.NewsletterSubscription')), 1)
                  ])
                ]),
                _createElementVNode("div", {
                  class: "desc small",
                  innerHTML: _unref(localizer).get('App.Form.PrivacyA', _unref(routes).UrlPrivacyPolicy)
                }, null, 8, _hoisted_30),
                (validationErrors.value.length !== 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                      _createElementVNode("ul", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(validationErrors.value, (validationError, index) => {
                          return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(validationError.message), 1))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_32, [
                  _createElementVNode("button", {
                    class: _normalizeClass([{ 'loading': isLoading.value }, 'button']),
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (submitForm()))
                  }, [
                    (!isLoading.value)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(_toDisplayString(_unref(localizer).get("Account.Common.Button_Next")), 1)
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 2)
                ])
              ])
            ], 512)
          ], 32))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})